import React from "react";
import "../styles/termsModal.css";

interface TermsModalProps {
  open: boolean;
  onAccept: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ open, onAccept }) => {
  const [agreed, setAgreed] = React.useState(false);

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h4>Términos y Condiciones de Uso</h4>
        <div className="modal-body">
          <p>
            Al usar esta aplicación, aceptas los{" "}
            <a href="https://ferrozmonheleworks.sbs/terminos" target="_blank" rel="noopener noreferrer">
              Términos y Condiciones
            </a>{" "}
            y la{" "}
            <a href="https://ferrozmonheleworks.sbs/politicas" target="_blank" rel="noopener noreferrer">
              Política de Privacidad
            </a>
            . Debes leerlos y aceptarlos para continuar.
          </p>
        </div>

        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          Acepto los términos y condiciones
        </label>

        <button
          className={`confirm-btn ${agreed ? "enabled" : "disabled"}`}
          onClick={onAccept}
          disabled={!agreed}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default TermsModal;